<template lang="pug">
.container
  gb-side-menu
  .loading-area(v-if="fetchLoading")
    vue-loading(
      type='spin'
      color="#F7CA18"
      :size="{ width: '60px', height: '60px' }"
    )
  .content-area(v-else)
    h3 施設一覧
    member-list-school(
      :memberList="memberList"
      @clickNurse="toNurseryList"
      @clickChild="toChildList"
      @changeIsDiary="changeIsDiary"
    )
</template>
<script>
import util from '@/api/util'
import { Cache } from 'aws-amplify'
import { VueLoading } from 'vue-loading-template'
import _ from 'lodash'
import LocalDataUtil from '@/util/LocalDataUtil.js'

import MemberListSchool from '@/components/organisms/MemberListSchool.vue'
import GbSideMenu from '@/components/organisms/GbSideMenu.vue'

export default {
  components: {
    VueLoading,
    GbSideMenu,
    MemberListSchool
  },
  data () {
    return {
      fetchLoading: true,
      childToSearch: false,
      classToAdd: false,
      memberList: []
    }
  },
  beforeMount: async function () {
    const isMaintenance = (await util.checkMaintenance({type: 'admin'})).data.data.is_maintenance
    if (isMaintenance) {
      this.$swal.fire({
        html: `現在メンテナンス中です`
      }).then(() => {
        this.$router.push({ name: 'Maintenance' })
      })
    } else {
      util.createMethod('COG', 'checkSessionExpired', null)
        .then(response => {
          if (response) {
            this.$router.push({ name: 'SignIn' })
          } else {
            Cache.clear()
            this.createAdminMast()
            this.fetchShoolList()
            // this.fetchCcsMastList()
          }
        })
    }
  },
  methods: {
    async createAdminMast () {
      const APPSYNC_REQUEST_VALUE = {
        sub: LocalDataUtil.getSub(),
        name: LocalDataUtil.getUserName(),
        name_kana: LocalDataUtil.getUserNameKana(),
        getChildminder: false,
        getRecord: false,
        editAdmin: false,
        getAdmin: false
      }
      util.createMethod('APPSYNC', 'createAdminMast', APPSYNC_REQUEST_VALUE)
    },
    async fetchShoolList () {
      try {
        this.memberList = []
        const CCS_REQUEST_VALUE = {
          session: LocalDataUtil.getCcsSession()
        }
        let serverIds = []
        const hostname = location.hostname
        const env = hostname.split('.')[0]
        if (env === 'local' || env === 'localhost' || env === 'qa1') {
          serverIds = ['ccsp-staging', 'ccsp-staging2']
        } else if (env === 'ccsapp') {
          serverIds = ['p001', 'p002']
        }
        await Promise.all(serverIds.map(async serverId => {
          const Response = (await util.createMethod('CCS', 'ccsFetchSchoolList', CCS_REQUEST_VALUE, null, serverId)).data.data
          this.memberList = this.memberList.concat(Response)
        }))
        const memberList = _.orderBy(this.memberList, ['nursery_name'])
        this.fetchLoading = false
        // const Response = (await util.createMethod('CCS', 'ccsFetchSchoolList', CCS_REQUEST_VALUE)).data.data
        // this.fetchLoading = false
        // this.memberList = _.orderBy(Response, ['nursery_name'])
        this.fetchSchoolMastList(memberList)
      } catch (error) {
        this.fetchLoading = false
        let dialog
        if (error.data.error) dialog = error.data.error
        else dialog = `エラーが発生しました`
        this.$swal.fire({
          html: `${dialog}`
        })
      }
    },
    async fetchSchoolMastList (memberList) {
      const Response = (await util.createMethod('APPSYNC', 'fetchSchoolMastList', null)).items.map(s => {
        const tmp = s.id.split('#')
        return {
          id: s.id,
          isDiaryEnabled: s.isDiaryEnabled,
          isEnableVevo: s.isEnableVevo,
          isMemoruEnabled: s.isMemoruEnabled,
          isVevo: s.isVevo,
          name: s.name,
          noteTimeLimit: s.noteTimeLimit,
          nurseryCode: tmp[1] ? tmp[1] : null,
          serverId: tmp[0] ? tmp[0] : null
        }
      })
      Response.map(r => {
        let members = memberList.map(m => {
          // console.log('よだんご1', m.nursery_code, r.nurseryCode)
          // console.log('よだんご2', m.server_id, r.serverId)
          if (m.nursery_code === r.nurseryCode && m.server_id === r.serverId) {
            // console.log('よだんご', r.isDiaryEnabled, m.nursery_code)
            if (m.isDiaryEnabled !== r.isDiaryEnabled) {
              m.isDiaryEnabled = r.isDiaryEnabled
            }
          } else if (m.isDiaryEnabled === null) {
            m.isDiaryEnabled = false
          }
          return m
        })
        // console.log9
        this.memberList = members
      })
    },
    // async fetchCcsMastList () {
    //   const Response = (await util.createMethod('APPSYNC', 'fetchCcsMastList', null)).items
    // },
    toNurseryList (nurseryData) {
      const nurseryCode = nurseryData.nursery_code
      const nurseryName = nurseryData.nursery_name
      this.$router.push({
        name: 'NurseList',
        params: {nurseryCode: nurseryCode, nurseryName: nurseryName}
      })
    },
    toChildList (nurseryData) {
      const nurseryCode = nurseryData.nursery_code
      const nurseryName = nurseryData.nursery_name
      this.$router.push({
        name: 'ChildList',
        params: {nurseryCode: nurseryCode, nurseryName: nurseryName}
      })
    },
    changeIsDiary (member) {
      const APPSYNC_REQUEST_VALUE = {
        id: member.server_id + '#' + member.nursery_code,
        isDiaryEnabled: member.isDiaryEnabled,
        isEnableVevo: member.isEnableVevo,
        isMemoruEnabled: member.isMemoruEnabled,
        isVevo: member.isVevo,
        name: member.name,
        noteTimeLimit: member.noteTimeLimit
      }
      util.createMethod('APPSYNC', 'updateSchoolMast', APPSYNC_REQUEST_VALUE)
        .then(response => {
          // this.memberList = this.memberList.map(m => {
          //   if (m.server_id === member.server_id && member.nursery_code === m.nursery_code) {
          //     m.isDiaryEnabled = !member.isDiaryEnabled
          //   }
          //   return m
          // })
          this.$swal.fire({
            text: `保育日誌有無を変更しました`
          }).then(() => {
            this.closeModal()
          })
        })
        .catch(() => {
          let dialog = `エラーが発生しました<br>時間をおいてもう一度お試しください`
          this.$swal.fire({html: `${dialog}`})
        })
    }
  }
}

</script>
<style lang="stylus" scoped>
@import '../stylus/main.styl'
.container
  width 100vw
  height 100vh
  display flex
  flex-direction row
.disable-card
  width 680px
  height 400px
  display flex
  flex-direction column
  justify-content space-between
.col-group
  display flex
  flex-direction column
.gb-card-cancel
  background-color #fff
  border-radius 2px
  padding-top 0
  padding-right 0
  display flex
  align-items flex-end
.cancel-box
  width 50px
  height 50px
  border-bottom 1px solid #000
  border-left 1px solid #000
  display grid
  align-items center
.cancel-bottom
  font-size 30px
  text-align center
  font-weight 300
</style>



// WEBPACK FOOTER //
// src/views/SchoolList.vue